export var ADDON_ID = 'storybook/background';
export var PARAM_KEY = 'backgrounds';
export var GRID_PARAM_KEY = 'grid';
export var EVENTS = {
  UPDATE: "".concat(ADDON_ID, "/update")
};